module.exports = __webpack_public_path__ + "d152c1c2be273a5a4bd56338695c03d0.png";